import React, { Component } from 'react';
import './index.scss';
import Layover from './LocationLayover';

class LocationSelector extends Component {
  constructor(props) {
    super(props);
    this.state={
      overlayVisibility:false
    }
  }

  closeOverlay = () =>{
      this.setState({
        overlayVisibility:false
      })
  }

  openOverlay = () =>{
    this.setState({
      overlayVisibility:true
    })
  }
  // selectedConversation={conversations.conversations[0]}
  // auth = {auth}
  // business ={business}
  // erorReport = {this.props.postErrorReport}
  // errorData = {this.props.conversations}
  // clearReportFlags ={this.props.clearReportFlags}

  render(){
  const { visibility, setLocationSelectorVisibility } = this.props;
  return (
    <div className="location-selector">
      <Layover 
          setLocationOverlayVisibility={setLocationSelectorVisibility} 
          modelopen={visibility} 
          selectedConversation = {this.props.selectedConversation}
          auth ={this.props.auth}
          business = {this.props.business}
          selectedLocation={this.props.selectedLocation}
          setSelectedLocation={this.props.setSelectedLocation}
          info={this.props.info}
          locations ={this.props.locations}

      />
    </div>
  );
  }
  
};

export default LocationSelector;
